export default "__VITE_ASSET__DXAtCuqa__"